import OnboardingHeader from "@/components/OnboardingHeader";
import { H1, H5 } from "@/components/Typography";
import useIsMobile from "@/utils/useIsMobile";
import { faSpinnerThird, faEnvelope } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { tv } from "tailwind-variants";

interface IProps {
  children: JSX.Element;
  whiteBackground?: boolean;
  hideHeader?: boolean;
  headingText: string;
  descriptionText: string | JSX.Element;
  isWaiting?: boolean;
}

const styles = tv({
  slots: {
    base: "flex h-screen w-screen bg-gradient-to-br from-primary to-green pt-onboarding-header-height-mobile md:bg-primary md:pt-onboarding-header-height",
    sizeContainer: "flex-grow",
    contentBox:
      "mx-auto flex max-w-full flex-col items-center justify-center rounded-sm p-20 px-20 pb-20 md:mt-[49px] md:max-w-[980px] md:border md:border-white",
    iconColor: "text-primary",
    icon: "h-[77px] w-[77px]",
    headerSection: "mb-10 mt-40 text-center md:mb-20",
    descriptionSection: "text-center",
    description: "text-secondary",
  },
  variants: {
    whiteBackground: {
      true: {
        contentBox: "bg-white px-20 py-50 md:px-[150px]",
        description: "text-secondary",
      },
      false: {
        base: "bg-gradient-to-br",
        contentBox: "mt-70 md:px-[100px] md:pb-130 md:pt-80",
        headerSection: "text-white",
        description: "text-white",
        iconColor: "text-white",
      },
    },
  },
});
const GradientWaitingRoom = ({
  children,
  whiteBackground,
  hideHeader,
  headingText,
  descriptionText,
  isWaiting = true,
}: IProps) => {
  const {
    base,
    sizeContainer,
    contentBox,
    iconColor,
    icon,
    headerSection,
    description,
    descriptionSection,
  } = styles({
    whiteBackground: whiteBackground,
  });

  const isMobile = useIsMobile();

  return (
    <div className={base()} data-testid="gradient-waiting-room">
      <div className={sizeContainer()}>
        {!hideHeader && (
          <OnboardingHeader overrideDarkButtons={isMobile && whiteBackground} />
        )}
        <div className={contentBox()}>
          <div className={iconColor()}>
            <FontAwesomeIcon
              icon={isWaiting ? faSpinnerThird : faEnvelope}
              className={icon()}
              spin={isWaiting}
              color="inherit"
            />
          </div>
          <div className={headerSection()}>
            <H1
              testId="gradient-header-text"
              color={whiteBackground ? "secondary" : "white"}>
              {headingText}
            </H1>
          </div>
          <div className={descriptionSection()}>
            <H5 className={description()} testId="gradient-description-text">
              {descriptionText}
            </H5>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default GradientWaitingRoom;
